import { React, useState, useEffect } from "react";
import HeaderB from "../Header/HeaderB";
import GoBackLink from "../GoBacklink/GoBackLink";
import ProductThumbNailGroup from "../ProductThumbNailGroup/ProductThumbNailGroup";
import AddToCart from "../AddToCart/AddToCart";
import BestGear from "../BestGear/BestGear";
import AlsoLike from "../AlsoLike/AlsoLike";
import speakerzx7Img from "../../assets/shared/desktop/image-zx7-speaker.jpg";
import Footer from "../Footer/Footer";
import Features from "../Features/Features";

import earphone from "../../assets/product-yx1-earphones/desktop/image-product.jpg";
import earphoneTab from "../../assets/product-yx1-earphones/tablet/image-product.jpg";
import earphoneMobile from "../../assets/product-yx1-earphones/mobile/image-product.jpg";
import speakerzx9Img from "../../assets/shared/desktop/image-zx9-speaker.jpg";
import speakerzx9ImgTab from "../../assets/shared/tablet/image-zx9-speaker.jpg";
import speakerzx9ImgMobile from "../../assets/shared/mobile/image-zx9-speaker.jpg";
import markOneImg from "../../assets/shared/desktop/image-xx99-mark-one-headphones.jpg";
import markOneImgTab from "../../assets/shared/tablet/image-xx99-mark-one-headphones.jpg";
import markOneImgMobile from "../../assets/shared/mobile/image-xx99-mark-one-headphones.jpg";
import xx59 from "../../assets/shared/desktop/image-xx59-headphones.jpg";
import xx59Tab from "../../assets/shared/tablet/image-xx59-headphones.jpg";
import xx59Mobile from "../../assets/shared/mobile/image-xx59-headphones.jpg";
import ProductGallery from "../ProductGallery/ProductGallery";
import imgGallery1 from "../../assets/product-yx1-earphones/desktop/image-gallery-1.jpg";
import imgGallery2 from "../../assets/product-yx1-earphones/desktop/image-gallery-2.jpg";
import imgGallery3 from "../../assets/product-yx1-earphones/desktop/image-gallery-3.jpg";

// import CartCheckOut from "../CartCheckOut/CartCheckOut";
const EarphoneDetail = ({
  addEarphoneToCart,
  updateMyCart,
  cart,
  updateQuantity,
  increment,
  decrement,
  quantity,
}) => {
  const [imgUrl, setImgURL] = useState("");
  const [speakerZx9Url, setSpeakerZx9Url] = useState("");
  const [markOneURL, setMarkOneURL] = useState("");
  const [xx59URL, setxx59URL] = useState("");
  useEffect(() => {
    const handleResize = () => {
      console.log("Resizing...");
      if (window.innerWidth <= 450) {
        setImgURL(earphoneMobile);
        setSpeakerZx9Url(speakerzx9ImgMobile);
        setMarkOneURL(markOneImgMobile);
        setxx59URL(xx59Mobile);
      } else if (window.innerWidth <= 768) {
        setImgURL(earphoneTab);
        setSpeakerZx9Url(speakerzx9ImgTab);
        setMarkOneURL(markOneImgTab);
        setxx59URL(xx59Tab);
      } else {
        setImgURL(earphone);
        setSpeakerZx9Url(speakerzx9Img);
        setMarkOneURL(markOneImg);
        setxx59URL(xx59);
      }

      console.log("Resize in Progress");
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <HeaderB
        updateCartQuantity={updateMyCart}
        cart={cart}
        increment={increment}
        decrement={decrement}
        quantity={quantity}
      />
      <main>
        {/* <CartCheckOut /> */}

        <GoBackLink />
        <AddToCart
          imageURL={imgUrl}
          productName={
            <>
              YX1 Wireless <br />
              Earphones
            </>
          }
          description="Tailor your listening experience with bespoke dynamic drivers from the new YX1 Wireless Earphones. 
          Enjoy incredible high-fidelity sound even in noisy environments with its active noise cancellation feature."
          price="599"
          addItem={updateMyCart}
          cart={cart}
          updateQuantity={updateQuantity}
          quantity={quantity}
          increment={increment}
          decrement={decrement}
        />
        <Features
          p1=" Experience unrivalled stereo sound thanks to innovative acoustic technology. With improved ergonomics 
          designed for full day wearing, these revolutionary earphones have been finely crafted to provide you with 
          the perfect fit, delivering complete comfort all day long while enjoying exceptional noise isolation and 
          truly immersive sound."
          p2="  The YX1 Wireless Earphones features customizable controls for volume, music, calls, and voice assistants 
          built into both earbuds. The new 7-hour battery life can be extended up to 28 hours with the charging case, 
          giving you uninterrupted play time. Exquisite craftsmanship with a splash resistant design now available in 
          an all new white and grey color scheme as well as the popular classic black."
        />
        <ProductGallery image={[imgGallery1, imgGallery2, imgGallery3]} />
        <AlsoLike
          image={[markOneURL, xx59URL, speakerZx9Url]}
          title={["XX99 MARK I", "XX59", "ZX9 SPEAKER"]}
          nav1={"/headphones/markOne"}
          nav2={"/headphones/xx59"}
          nav3={"/speakerZx9"}
        />
        <ProductThumbNailGroup />
        <BestGear />
        <Footer />
      </main>
    </>
  );
};

export default EarphoneDetail;
